import Vue from "vue";
// import {
//   i18n
// } from '@/main.js';
import i18n from "@/lang/index";
export function isMobile() {
  // 判断当前设备种类 true为移动端设备 false为PC端设备
  // 首先检查 userAgent 中是否包含移动设备相关关键词
  const userAgentMatch = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Windows Phone)/i
  );

  // 然后检查屏幕宽度，通常移动端屏幕宽度小于 768px
  const screenWidthMatch = window.innerWidth < 768;

  // 只要满足其中一个条件，就认为是移动端设备
  return !!userAgentMatch || screenWidthMatch;
}

export function setRem(designWidth = 750, baseSize = 100) {
  const html = document.documentElement;
  const clientWidth = html.clientWidth;

  // 防止客户端宽度过小或为 0
  if (clientWidth) {
    let ratio;
    // 根据不同屏幕宽度区间设置不同的缩放比例
    if (clientWidth < 480) {
      // 超小屏幕设备，如手机竖屏
      ratio = 0.4;
    } else if (clientWidth < 768) {
      // 小屏幕设备，如手机横屏或平板竖屏
      ratio = 0.25;
    } else if (clientWidth < 992) {
      // 中等屏幕设备，如平板横屏
      ratio = 0.2;
    } else if (clientWidth < 1200) {
      // 大屏幕设备，如笔记本电脑
      ratio = 0.16;
    } else {
      // 超大屏幕设备，如台式机显示器
      ratio = 0.1;
    }
    // 计算当前页面宽度下的 font - size 值
    const fontSize = (clientWidth / designWidth) * baseSize * ratio;
    html.style.fontSize = fontSize + "px";
  }
}

// 首次加载时设置 rem
setRem();

// 监听窗口大小变化事件，重新设置 rem
// window.addEventListener("resize", () => {
//   // TODO 考虑是否在切换rem值的时候刷新页面
//   // location.reload();
//   setRem();
// });

// 监听页面方向变化事件，重新设置 rem
window.addEventListener("orientationchange", () => {
  setRem();
});

/**
 * 千分位显示，并保留decimalPlaces位小数,截断  flag为true显示千位符，
 */
// 处理小数位（支持超大整数，避免四舍五入）
Vue.filter("formatThous", function (num, flag = true, decimalPlaces = 4) {
  if (num === null || num === undefined || num === "") return "0";

  // 转换为字符串（避免 Number 精度丢失）
  const numStr = String(num);

  // 处理科学计数法（直接字符串操作，避免 Number 转换）
  const processedStr = scientificToDecimalString(numStr);

  // 分割整数和小数部分
  const [integerPart, decimalPart = ""] = processedStr.split(".");

  // 添加千位分隔符（字符串版 toLocaleString）
  let formattedInteger;
  if (flag) {
    formattedInteger = addThousandSeparators(integerPart); // 纯字符串处理
  } else {
    formattedInteger = integerPart;
  }

  // 截取指定小数位数（直接字符串截取）
  const truncatedDecimal = decimalPart
    .slice(0, decimalPlaces)
    .replace(/0+$/, "");

  // 拼接结果
  return truncatedDecimal
    ? `${formattedInteger}.${truncatedDecimal}`
    : formattedInteger;
});

// 科学计数法转字符串（纯字符串操作）
function scientificToDecimalString(numStr) {
  if (!numStr.includes("e")) return numStr;

  const [coefficient, exponent] = numStr.split("e");
  const exp = parseInt(exponent, 10);
  const [integer, decimal = ""] = coefficient.split(".");

  // 合并整数和小数部分为纯小数形式（如 "1.23e+3" → "1230"）
  const pureDecimalStr = decimal ? `${integer}${decimal}` : integer;

  if (exp > 0) {
    // 正指数：移动小数点向右（如 "123e+3" → "123000"）
    const shift = exp - decimal.length;
    if (shift >= 0) {
      return `${pureDecimalStr}${"0".repeat(shift)}`;
    } else {
      const pos = pureDecimalStr.length + shift;
      return `${pureDecimalStr.slice(0, pos)}.${pureDecimalStr.slice(pos)}`;
    }
  } else {
    // 负指数：移动小数点向左（如 "123e-3" → "0.123"）
    const absExp = Math.abs(exp);
    const leadingZeros = "0".repeat(absExp - 1);
    return `0.${leadingZeros}${pureDecimalStr}`;
  }
}

// 字符串版千位分隔符（避免 Number 转换）
function addThousandSeparators(str) {
  return str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
const scientificToDecimal = (num) => {
  const numStr = num.toString();
  if (numStr.includes("e")) {
    const [coefficient, exponent] = numStr.split("e");
    const exp = parseInt(exponent, 10);
    const [integer, decimal = ""] = coefficient.split(".");
    if (exp > 0) {
      const paddedDecimal = (decimal + "0".repeat(exp)).slice(0, exp);
      return integer + paddedDecimal;
    } else {
      const leadingZeros = "0".repeat(Math.abs(exp) - 1);
      return `0.${leadingZeros}${integer}${decimal}`;
    }
  }
  return numStr;
};
Vue.filter("formatNumber", function (num) {
  if (num) {
    if (num >= 1e8) {
      return `${(num / 1e8).toFixed(2)} ${i18n.t("亿")}`;
    } else if (num >= 1e4) {
      return `${(num / 1e4).toFixed(2)} ${i18n.t("万")
        }`;
    }
    return num.toString();
  } else {
    return 0;
  }
});
Vue.filter("timeAgo", function (createTime) {
  const createDate = new Date(createTime);
  const now = new Date();
  const diffInMs = now - createDate; // 时间差（毫秒）

  const diffInSeconds = Math.floor(diffInMs / 1000);
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);

  if (diffInDays > 0) {
    return `${diffInDays + " " + i18n.t("天前")}`;
  } else if (diffInHours > 0) {
    return `${diffInHours + " " + i18n.t("小时前")}`;
  } else if (diffInMinutes > 0) {
    return `${diffInMinutes + " " + i18n.t("分钟前")}`;
  } else {
    return i18n.t("刚刚"); // Less than a minute
  }
});
Vue.filter("formatTime", function (timestamp) {
  if (!timestamp) return "";
  const date = new Date(timestamp * 1000); // 如果是秒级时间戳需要乘以1000
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hour = date.getHours().toString().padStart(2, "0");
  const minute = date.getMinutes().toString().padStart(2, "0");
  const second = date.getSeconds().toString().padStart(2, "0");

  return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
});
// TOTEST 需测试是否兼容移动端浏览器
export const clipboard = {
  async copy(text) {
    // 新浏览器使用API
    if (navigator.clipboard) {
      try {
        return await navigator.clipboard.writeText(text);
      } catch (err) {
        console.error("Async clipboard copy failed:", err);
        return await this.legacyCopy(text);
      }
    }
    return this.legacyCopy(text);
  },

  legacyCopy(text) {
    return new Promise((resolve, reject) => {
      // 创建临时textarea
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.left = "-9999px";

      document.body.appendChild(textarea);
      textarea.select();

      try {
        // 兼容老版本iOS
        const success = document.execCommand("copy");
        document.body.removeChild(textarea);
        success ? resolve() : reject(new Error("Copy failed"));
      } catch (err) {
        document.body.removeChild(textarea);
        reject(err);
      }
    });
  },
  async paste() {
    // 新浏览器使用API
    if (navigator.clipboard) {
      try {
        return await navigator.clipboard.readText();
      } catch (err) {
        console.error("Async clipboard read failed:", err);
        return this.legacyPaste();
      }
    }
    return this.legacyPaste();
  },

  legacyPaste() {
    return new Promise((resolve) => {
      const input = document.createElement("input");
      input.style.cssText = `
			position: fixed;
			top: 10%;
			left: 50%;
			transform: translateX(-50%);
			width: 200px;
			height: 20px;
			opacity: 0.01;
			z-index: 9999;
		  `;

      input.addEventListener(
        "paste",
        (e) => {
          const content = e.clipboardData.getData("text/plain");
          resolve(content);
          document.body.removeChild(input);
        },
        { once: true }
      );

      document.body.appendChild(input);
      input.focus();

      setTimeout(() => {
        if (document.body.contains(input)) {
          console.warn("粘贴超时");
          resolve(null);
          document.body.removeChild(input);
        }
      }, 1000);
    });
  },
};
export const langList = {
  Lang: [
    { id: 1, title: "简体中文", label: "简体中文", value: "zh" },
    { id: 2, title: "English", label: "英语", value: "en" },
  ],
};
export const debounceImmediate = (func, wait, immediate = true) => {
  let lastTime = 0;
  let timer = null;
  return function () {
    const context = this;
    const args = arguments;
    const now = Date.now();
    if (immediate && now - lastTime >= wait) {
      // 立即执行模式且满足等待时间
      func.apply(context, args);
      lastTime = now;
    } else if (!immediate) {
      // 非立即执行模式
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(context, args);
      }, wait);
    } else {
      // 不满足条件，显示提示
      // uni.$u.toast(context.$t("操作频繁,请稍后再试"));

      // 仍然重置计时器，确保下次能执行
      clearTimeout(timer);
      timer = setTimeout(() => {
        lastTime = 0;
      }, wait - (now - lastTime));
    }
  };
};
// 处理小数位
Vue.filter("formatThous", function (num, flag = true, decimalPlaces = 4) {
  if (num === null || num === undefined || num === "") return "0";
  // 处理科学计数法
  const numStr = scientificToDecimal(Number(num));
  // 分割整数和小数部分
  const [integerPart, decimalPart = ""] = numStr.split(".");
  // 添加千位分隔符（如 "1234567" → "1,234,567"）
  // .toLocaleString()
  let formattedInteger;
  if (flag) {
    formattedInteger = parseInt(integerPart, 10).toLocaleString();
  } else {
    formattedInteger = parseInt(integerPart, 10);
  }
  // 截取指定小数位数
  const truncatedDecimal = decimalPart
    .slice(0, decimalPlaces)
    .replace(/0+$/, "");
  // 拼接结果
  return truncatedDecimal
    ? `${formattedInteger}.${truncatedDecimal}`
    : formattedInteger;
});

/**
 * 截取地址变成 0x12...1234
 */
export const toolAddr = (a) => {
  if (a) {
    if (a.length > 8) {
      return a.substr(0, 4) + "..." + a.substr(a.length - 4);
    } else {
      return a;
    }
  } else {
    return "--";
  }
};
